<template lang="html">
  <div class="">
    <div v-if="display" style="white-space: pre-wrap; page-break-inside: avoid;">{{value || '-'}}</div>
    <v-select
      v-else
      :value="value"
      v-on="$listeners"
      v-bind="$attrs"
      :items="seatingOptions"
      item-value="label"
      item-text="displayLabel"
      clearable
    >
      <template #item="{item}">
        <div class="my-1">
          <div>{{item.label}}</div>
          <div class="text--secondary" style="font-size: 0.9rem;">{{item.seats}} platser</div>
        </div>
      </template>
    </v-select>
  </div>
</template>

<script>
import {getItemById} from '@dynapp/wc-api-generic';

export default {
  name: 'SeatingInput',
  props: {
    calendar: {},
    item: {},
    value: {},
    display: {}
  },
  data() {
    return {
      resources: []
    };
  },
  computed: {
    seatingOptions() {
      var seatingFields = (
        (
          this.calendar.extra_fields_resources || []
        ).filter(s => s.title == 'Seating')[0] || {}
      ).fields || [];
      var options = seatingFields.map(field => {
        var seats = this.optionSeats(field)
        return {
          ...field,
          seats: seats,
          displayLabel: `${field.label} - upp till ${seats} platser`
        }
      });
      options = options.filter(option => option.seats > 0);
      return options;
    },
    itemResources() {
      var resources = this.item.expanded_resources || this.item.resources || [];
      if (typeof resources[0] == 'string') {
        resources = resources.map(
          resourceId => getItemById(this.$store.getters[`bookings/${this.calendar.id}/resources/items`], resourceId)
        );
        resources = resources.filter(r => !!r);
      }
      return resources;
    }
  },
  methods: {
    optionSeats(option) {
      var key = option.key;
      var seatTotal = 0;
      this.itemResources.forEach(resource => {
        seatTotal += Number((resource.extra || {})[key] || 0);
      });
      return seatTotal;
    }
  }
}
</script>

<style lang="css" scoped>
</style>
